"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _url = require("url");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _debug = _interopRequireDefault(require("debug"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _APIRequestPanel = _interopRequireDefault(require("./APIRequestPanel"));
var localStorageUtils = _interopRequireWildcard(require("../../utils/localStorage"));
var utils = _interopRequireWildcard(require("./utils"));
var _analytics = _interopRequireWildcard(require("../../utils/analytics"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LOCAL_STORAGE_KEY = 'isAPIBehindFirewall';
var log = (0, _debug.default)('apiconsole:components:apirequestpanel');
var UNAUTHENTICATED_ACCESS_CODES = ['UNAUTHORIZED_ACCESS_TO_RESOURCE', 'UNAUTHENTICATED'];
var getAPIFirewallKey = function getAPIFirewallKey(_ref) {
  var groupId = _ref.groupId,
    assetId = _ref.assetId;
  return "".concat(groupId, "/").concat(assetId);
};
var apiConsoleRequest = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref2) {
    var organizationId, authorization, isAPIBehindFirewall, isExternalDomain, isForwardedHost, isMockingServiceInstance, organizationDomain, proxyURL, requestDetail, apiResponse, response, responseText, code, unauthorizedError, responseEvent;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          organizationId = _ref2.organizationId, authorization = _ref2.authorization, isAPIBehindFirewall = _ref2.isAPIBehindFirewall, isExternalDomain = _ref2.isExternalDomain, isForwardedHost = _ref2.isForwardedHost, isMockingServiceInstance = _ref2.isMockingServiceInstance, organizationDomain = _ref2.organizationDomain, proxyURL = _ref2.proxyURL, requestDetail = _ref2.requestDetail;
          _context.next = 3;
          return utils.apiRequest({
            organizationId: organizationId,
            authorization: authorization,
            isAPIBehindFirewall: isAPIBehindFirewall,
            isExternalDomain: isExternalDomain,
            isForwardedHost: isForwardedHost,
            isMockingServiceInstance: isMockingServiceInstance,
            organizationDomain: organizationDomain,
            proxyURL: proxyURL,
            requestDetail: requestDetail
          });
        case 3:
          apiResponse = _context.sent;
          response = apiResponse.response;
          _context.next = 7;
          return response.text();
        case 7:
          responseText = _context.sent;
          if (!(response.status === 401)) {
            _context.next = 14;
            break;
          }
          try {
            // eslint-disable-next-line prefer-destructuring
            code = JSON.parse(responseText).code;
          } catch ($error) {
            // nothing to do here
          }
          if (!UNAUTHENTICATED_ACCESS_CODES.includes(code)) {
            _context.next = 14;
            break;
          }
          unauthorizedError = new Error('Unauthorized');
          unauthorizedError.status = 401;
          throw unauthorizedError;
        case 14:
          responseEvent = utils.toARCResponseEvent(_objectSpread(_objectSpread({}, apiResponse), {}, {
            responseText: responseText,
            requestId: requestDetail.id
          }));
          log('emitting api-response event', responseEvent);
          global.document.body.dispatchEvent(responseEvent);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function apiConsoleRequest(_x) {
    return _ref3.apply(this, arguments);
  };
}();
var APIRequestPanelController = function APIRequestPanelController(_ref4) {
  var _config$apiPortals;
  var asset = _ref4.asset,
    amfModel = _ref4.amfModel,
    apiInstances = _ref4.apiInstances,
    apiSpecBaseURI = _ref4.apiSpecBaseURI,
    selected = _ref4.selected;
  var _React$useState = _react.default.useState(),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    apiFirewallSettings = _React$useState2[0],
    setAPIFirewallSettings = _React$useState2[1];
  var _React$useContext = _react.default.useContext(_exchangeReactHooks.AnalyticsContext),
    trackEvent = _React$useContext.trackEvent;
  var _React$useContext2 = _react.default.useContext(_exchangeReactHooks.UserContext),
    authorization = _React$useContext2.context.authorization;
  var config = _react.default.useContext(_exchangeReactHooks.ConfigContext);
  var handleError = _react.default.useContext(_exchangeReactHooks.ErrorHandlingContext);
  var _React$useContext3 = _react.default.useContext(_exchangeReactHooks.RouterContext),
    _React$useContext3$co = _React$useContext3.context,
    isForwardedHost = _React$useContext3$co.isForwardedHost,
    host = _React$useContext3$co.host;
  var isAPIConsoleProxyEnabled = !!((_config$apiPortals = config.apiPortals) !== null && _config$apiPortals !== void 0 && (_config$apiPortals = _config$apiPortals.apiConsole) !== null && _config$apiPortals !== void 0 && _config$apiPortals.proxy);
  var proxyURL = isAPIConsoleProxyEnabled ? (0, _url.format)(_objectSpread(_objectSpread({}, config.platform.uri), config.apiPortals.apiConsole.proxy.uri)) : null;
  var _asset$organization = asset.organization,
    organizationId = _asset$organization.id,
    organizationDomain = _asset$organization.domain;
  var apiFirewallKey = getAPIFirewallKey(asset);
  var apiFirewallEnabled = !!apiFirewallSettings && apiFirewallSettings[apiFirewallKey];
  _react.default.useEffect(function () {
    var settings = localStorageUtils.getItem(LOCAL_STORAGE_KEY);
    setAPIFirewallSettings(settings);
  }, []);
  var getServerTypeFromServer = function getServerTypeFromServer(selectedUri, type) {
    if (type !== 'server') {
      var apiInstance = apiInstances.find(function (_ref5) {
        var endpointUri = _ref5.endpointUri;
        return endpointUri === selectedUri;
      });
      return !!apiInstance && apiInstance.type;
    }
    return 'apiSpecURI';
  };
  return /*#__PURE__*/_react.default.createElement(_APIRequestPanel.default, {
    asset: asset,
    amfModel: amfModel,
    apiInstances: apiInstances,
    isAPIConsoleProxyEnabled: isAPIConsoleProxyEnabled,
    apiFirewallEnabled: apiFirewallEnabled,
    apiSpecBaseURI: apiSpecBaseURI,
    selected: selected,
    authorization: authorization,
    organizationId: organizationId,
    organizationDomain: organizationDomain,
    onSaveAPIFirewallSettings: function onSaveAPIFirewallSettings(updatedValue) {
      var newSettings = _objectSpread(_objectSpread({}, apiFirewallSettings), {}, (0, _defineProperty2.default)({}, apiFirewallKey, updatedValue));
      trackEvent(_analytics.default.API_REQUEST_PANEL_FIREWALL_TOGGLE_CLICKED, _objectSpread(_objectSpread({}, (0, _analytics.getAssetProperties)({
        asset: asset
      })), {}, {
        firewallToggleActivated: updatedValue
      }));
      setAPIFirewallSettings(newSettings);
      localStorageUtils.setItem(LOCAL_STORAGE_KEY, newSettings);
    },
    onAPIConsoleRequest: function onAPIConsoleRequest(_ref6) {
      var isAPIBehindFirewall = _ref6.isAPIBehindFirewall,
        isMockingServiceInstance = _ref6.isMockingServiceInstance,
        request = _ref6.request,
        serverValue = _ref6.serverValue,
        serverType = _ref6.serverType;
      var isExternalDomain = utils.urlInExternalDomain(serverValue, isForwardedHost, host, config);
      trackEvent(_analytics.default.API_REQUEST_PANEL_REQUEST_MADE, _objectSpread(_objectSpread({}, (0, _analytics.getAssetProperties)({
        asset: asset
      })), {}, {
        serverType: getServerTypeFromServer(serverValue, serverType),
        isExternalDomain: isExternalDomain,
        isUsingAPIConsoleProxy: utils.shouldUseAPIConsoleProxy({
          isAPIConsoleProxyEnabled: isAPIConsoleProxyEnabled,
          isExternalDomain: isExternalDomain,
          isAPIBehindFirewall: isAPIBehindFirewall
        })
      }));
      var doRequest = function doRequest() {
        return apiConsoleRequest({
          organizationId: organizationId,
          authorization: authorization,
          organizationDomain: organizationDomain,
          isForwardedHost: isForwardedHost,
          isAPIBehindFirewall: isAPIBehindFirewall,
          isMockingServiceInstance: isMockingServiceInstance,
          proxyURL: proxyURL,
          requestDetail: request,
          isExternalDomain: isExternalDomain
        });
      };
      try {
        doRequest();
      } catch (error) {
        handleError(error, doRequest);
      }
    },
    onServerSelectorChanged: function onServerSelectorChanged(value, type) {
      trackEvent(_analytics.default.API_REQUEST_PANEL_SERVER_SELECTION_CHANGED, _objectSpread(_objectSpread({}, (0, _analytics.getAssetProperties)({
        asset: asset
      })), {}, {
        serverType: getServerTypeFromServer(value, type)
      }));
    }
  });
};
APIRequestPanelController.propTypes = {
  amfModel: _propTypes.default.array,
  apiInstances: _propTypes.default.array,
  apiSpecBaseURI: _propTypes.default.string,
  asset: _propTypes.default.any,
  selected: _propTypes.default.string
};
var _default = exports.default = APIRequestPanelController;
//# sourceMappingURL=APIRequestPanelController.js.map